import { OPTIMIZELY_FEATURE_ON, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { isNewUser } from 'utils/new-user-experiment';
export const useSortBy = () => {
    const sortByVariation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_NEW_USER);
    const isSortByFlagOn = sortByVariation === OPTIMIZELY_FEATURE_ON;
    const isNew = isNewUser();
    const selectedSortBy = isSortByFlagOn && isNew ? 'new_user_relevance' : 'relevance';
    return selectedSortBy;
};
